export default "__VITE_PUBLIC_ASSET__0d8c0544__"